const ADD_ROUTE_HISTORY = (state, value) => {
  state.history.push(value);
}

export default {
	ADD_ROUTE_HISTORY
}